import { Manager } from "./manager";
import { Team } from "./team";

export class User {
    UserID : number;
    Name : string;
    Email : string;
    IsActive : boolean;
    personType : string;
    manager : Manager;
    team : Team;
     hr?: {
        hrId: number;
        tenantId: number;
        name: string;
    };

    constructor() {
        this.UserID = 0;
        this.Name = "";
        this.Email = "";
        this.IsActive = false;
        this.personType = "";
        this.manager = new Manager();
        this.team = new Team();
        this.hr = {
            hrId: 0,
            tenantId: 0,
            name: ""
        };
    }
}